export enum EFilters {
  PRODUCTS = 'Products',
  INGREDIENTS = 'INGREDIENTS'
}
